import type { StatePropsOfMasterItem } from '@jsonforms/core';
import { withJsonFormsMasterListItemProps } from '@jsonforms/react';
import { ActionIcon, Avatar, Group, ListItem, Text, Tooltip } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import React from 'react';

export const ListWithDetailMasterItem = ({
  index,
  childLabel,
  selected,
  enabled,
  handleSelect,
  removeItem,
  path,
  translations,
  disableRemove,
}: StatePropsOfMasterItem & { disableRemove?: boolean }) => {
  return (
    <ListItem icon={<Avatar color={selected ? 'teal.6' : 'gray.6'}>{index}</Avatar>} onClick={handleSelect(index)}>
      <Group justify='space-between'>
        <Text>{childLabel}</Text>
        {enabled && !disableRemove && (
          <Tooltip id='tooltip-remove' label={translations.removeTooltip} position='bottom'>
            <ActionIcon aria-label={translations.removeAriaLabel} onClick={removeItem(path, index)} size='large'>
              <IconTrash />
            </ActionIcon>
          </Tooltip>
        )}
      </Group>
    </ListItem>
  );
};

export default withJsonFormsMasterListItemProps(ListWithDetailMasterItem);
